import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal",
  "data-dismiss": "modal"
}
const _hoisted_2 = { class: "svg-icon svg-icon-1" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    identifier: _ctx.id,
    "modal-dialog-classes": "modal-xl modal-dialog-scrollable"
  }, {
    header: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("h2", { class: "fw-bolder" }, "Express data entry", -1)
    ])),
    "header-close": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
        ])
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", {
        id: `${_ctx.id}-body`,
        class: "row"
      }, null, 8, _hoisted_3)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary btn-active-primary m-5",
          id: `${_ctx.id}-submit`,
          title: "You could either enter the required details in the opened window or directly in the company/employee profiles"
        }, " Express data submit ", 8, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["identifier"]))
}